import React from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Footer from "../Footer";

const NewSubCategory = () => {
  return (
    <>
    <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper" style={{paddingRight:"0px", paddingLeft:"0px"}}>
          <Sidebar />

          Add new Sub Categorty Here
        </div>
    <Footer />
    </div>
    </>
  )
}

export default NewSubCategory
